<template>
  <div>
    <q-panel>
      <div v-if="post.image">
        <img
          class="img-responsive post-title"
          :src="post.image"
          :alt="post.title"
        >
      </div>

      <div class="panel-heading">
        <div class="bb">
          <h2 class="text-lg">
            {{ post.title }}
          </h2>
          <p class="clearfix">
            <span class="pull-right">
              <small
                class="mr-sm"
                dir="ltr"
              >
                <strong>{{ post.author }}</strong>
                <span>:</span>
                <span>{{ this.$qt('post.authorByText') }}</span>
              </small>
              -
              <small
                class="mr-sm"
                dir="ltr"
              >
                {{ post.date }}
              </small>
              -
              <small dir="ltr">
                <strong>{{ post.commentQty }}</strong>
                <span>:</span>
                <span>{{ this.$qt('post.comment.comments') }}</span>
              </small>
            </span>
          </p>
        </div>
      </div>

      <div class="panel-body">
        <div
          v-if="post.textType === 'Marked'"
          style="padding: 20px"
          v-html="compiledMarkdown"
        />
        <div
          v-else-if="post.textType === 'Html'"
          v-html="post.text"
        />
        <div
          v-else-if="post.textType === 'Textuality'"
          style="padding: 20px"
        >
          <p>{{ post.text }}</p>
        </div>
        <div v-else>
          <span>{{ this.$qt('post.emptyText') }}</span>
        </div>


        <q-tag
          v-for="tag in post.tags"
          :key="tag.key"
          class="post-tag"
          :type="tag.key"
        >
          {{ tag.value }}
        </q-tag>
      </div>

      <span
        slot="footer"
        class="dialog-footer clearfix"
      >
        <div
          class="pull-right"
          style="padding-left: 10px"
        >
          <!--          <router-link :to="{ name: 'dashboard'}">-->
          <!--            <q-link-->
          <!--              :underline="false"-->
          <!--              class="q-link"-->
          <!--            >-->
          <!--              <span>DASHBOARD</span>-->
          <!--            </q-link>-->
          <!--          </router-link>-->
          <!--          <q-divider direction="vertical" />-->
        </div>
        <div
          class="pull-left"
          style="padding-right: 10px"
        >
          <q-link
            :underline="false"
            class="q-link"
            target="_blank"
            href="https://twitter.com/atrvasa"
          >
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </q-link>
          <q-divider direction="vertical" />
        </div>

      </span>
    </q-panel>

    <div v-if="post.id !== undefined">
      <q-panel>
        <div class="panel-heading">
          <span>{{ this.$qt('post.comment.comments') }}</span>
          <span>:</span>
          <strong>{{ post.commentQty }}</strong>
        </div>
        <comments :comments="post.comments" />
      </q-panel>

      <q-panel
        v-if="this.$store.state.session.sessionId !== 'GUEST'"
        :header-text="this.$qt('post.comment.addCommentTitle')"
      >
        <div class="panel-padding">
          <add-comment
            :post-id="post.id"
            @comment-added="refreshComments"
          />
        </div>
      </q-panel>
    </div>
  </div>
</template>

<script>
  import addComment from "./addComment";
  import comments from "./comments";
  import marked from 'marked'


  export default {
    name: "Post",

    components: {
      'add-comment': addComment,
      'comments': comments
    },

    props: {
      id: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        input: "# 1",
        post: {},
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize(to.params.id));
    },
    beforeRouteUpdate(to, from, next) {
      this.initialize(to.params.id);
      next(vm => vm.initialize(to.params.id));


    },

    computed: {
      compiledMarkdown() {
        if (this.post.text)
          return marked(this.post.text, {sanitize: true});
        else
          return '';
      }
    },
    methods: {
      initialize(postId) {
        this.$delegate('edms', 'getContentAsPost', {
          id: postId
        }).then((res) => {
          this.post = res.result;
        }).catch(() => {
        });
      },
      refreshComments(comments) {
        this.post.comments = comments;
        this.post.commentQty = comments.length;
      }
    }
  }
</script>

<style scoped>
  .post-tag {
    margin: 0 3px;
  }
</style>